import styles from './CommentsCell.module.scss';
import { useState, useRef, useEffect } from 'react';
import Tooltip from '../../../_custom/Tooltip/Tooltip';
import { addNewDealNotesPurple, editDealCommentsPurple } from '../../../../assets/hostedassets';
import clsx from 'clsx';

type CommentsBoxProps = {
    text: string;
    handleChange: (text: string) => void;
    timestamp?: string;
    disabled?: boolean;
};

const CommentsCell = ({ text, handleChange, timestamp, disabled }: CommentsBoxProps) => {
    const [editing, setEditing] = useState<'NEW' | 'EDIT' | ''>('');
    const [isHovered, setIsHovered] = useState(false);
    const [commentText, setCommentText] = useState(text || '');
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        setCommentText(text || '');
    }, [text]);

    const truncateTextTo2Lines = (text: string) => {
        if (text?.length > 60) {
            return text.slice(0, 60) + '...';
        }
        return text;
    };

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (!textarea) return;
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
    };

    useEffect(() => {
        adjustTextareaHeight();
    }, [commentText, editing]);

    const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (disabled) return;
        setCommentText(e.target.value);
    };

    const handleSave = () => {
        handleChange(commentText);
        setEditing('');
        setIsHovered(false);
    };

    const renderCommentsBox = () => {
        if (editing === 'EDIT' || editing === 'NEW') {
            return (
                <>
                    <div
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setIsHovered(false);
                            setCommentText(text || '');
                            setEditing('');
                        }}
                        className={styles.overlay}
                    />
                    <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                        <div className={clsx(styles.CommentsEditBox, { [styles.CommentsBoxDisabled]: disabled })}>
                            <textarea
                                ref={textareaRef}
                                onDragStart={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }}
                                className={styles.TextArea}
                                value={commentText}
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                onChange={handleTextChange}
                            />
                            <div className={styles.ButtonContainer}>
                                <button
                                    className={styles.CancelButton}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsHovered(false);
                                        setCommentText(text || '');
                                        setEditing('');
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    className={styles.SubmitButton}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleSave();
                                    }}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
        return (
            <div
                style={{ width: '100%', height: '3.5rem' }}
                onMouseEnter={() => {
                    if (disabled) return;
                    setIsHovered(true);
                }}
                onMouseLeave={() => setIsHovered(false)}
            >
                <Tooltip content={disabled ? '' : commentText} direction={'left'} containerFullWidth containerFullHeight fitContent>
                    <div className={styles.CommentsBox}>
                        <div className={styles.Comments}>
                            {commentText ? (
                                <span className={clsx(styles.CommentsText, { [styles.CommentsTextdisabled]: disabled })}>
                                    {truncateTextTo2Lines(commentText)}
                                    {timestamp && (
                                        <div style={{ color: '#9D9D9D', fontSize: '0.625rem', marginTop: '2px' }}>{timestamp}</div>
                                    )}
                                </span>
                            ) : (
                                <span className={styles.CommentsTextCentered}>Add Remarks</span>
                            )}
                        </div>
                        <div
                            onClick={(e) => e.stopPropagation()}
                            className={isHovered ? styles.ButtonContainerVisible : styles.ButtonContainerHidden}
                        >
                            <button
                                className={styles.CommentButton}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setEditing('NEW');
                                    setCommentText('');
                                }}
                            >
                                <img src={addNewDealNotesPurple} alt={'addNewDealNotesPurple'} height={'12.5px'} />
                                Add New
                            </button>
                            <button
                                className={styles.CommentButton}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setEditing('EDIT');
                                }}
                            >
                                <img src={editDealCommentsPurple} alt={'editDealCommentsPurple'} height={'12.5px'} />
                                Edit
                            </button>
                        </div>
                    </div>
                </Tooltip>
            </div>
        );
    };
    return <>{renderCommentsBox()}</>;
};

export default CommentsCell;
